const RandomImage = () => {
	if (document.body.classList.contains('neos-backend')) {
		return;
	}

	Array.from(document.querySelectorAll('.random-image-container')).forEach(imageGroup => {
		let images = imageGroup.querySelectorAll('.image-element');
		console.log(images)
		let i = 0;
		let visibleIndex = Math.floor(Math.random() * (images.length - 1 - i + 1) + i);
		for (i; i < images.length; i++) {
			console.log(i + ' vs' + visibleIndex);
			if (i !== visibleIndex) {
				images[i].style.display = 'none';
			}
		}
	});
};

export default RandomImage;
